import React from "react";
import { MessageDisplay } from "./MessageDisplay/MessageDisplay.js";
import styled from "styled-components";
import { COLORS } from "../../../../../../assets/constants/styles";

const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const MessagesRenderer = ({ messages, t }) => {
  if (!Array.isArray(messages) || messages.length === 0) return null;

  return (
    <MessagesContainer>
      {messages.map((message, index) => (
        <MessageDisplay key={index} message={message} t={t} />
      ))}
    </MessagesContainer>
  );
};
